import React, { useCallback, useMemo } from 'react'

import Toast from '$extensionSrc/components/Toast'
import {
  extensionRedirectPath,
  selectPlanPath,
} from '$extensionSrc/consts/urlConsts'

import Confirm2faForm from './Confirm2faForm'

export default function Confirm2faPage({
  hasActivePlan,
  onSkip,
  onSuccess,
  phoneNumber,
  showSkip,
  twofaMethod,
  userFlow,
  next,
}: {
  hasActivePlan: boolean
  onSkip?: () => void
  onSuccess?: () => void
  phoneNumber?: string
  showSkip: boolean
  twofaMethod: 'app' | 'sms'
  userFlow: 'signup' | 'login'
  next?: string
}) {
  const destination = useMemo(
    () => next || (hasActivePlan ? extensionRedirectPath : selectPlanPath),
    [hasActivePlan, next],
  )

  const defaultOnSkip = useCallback(() => {
    window.location.assign(destination)
  }, [destination])

  const defaultOnSuccess = useCallback(() => {
    window.location.assign(destination)
  }, [destination])

  const error = useMemo(
    () =>
      twofaMethod === 'sms' && !phoneNumber ? (
        <>
          There isn&apos;t a phone number associated with your account. Please
          contact{' '}
          <a href="mailto:support@blockpartyapp.com">
            support@blockpartyapp.com
          </a>
          .
        </>
      ) : undefined,
    [phoneNumber, twofaMethod],
  )

  return (
    <div className="Confirm2faPage">
      {!error && (
        <Confirm2faForm
          onSkip={onSkip || defaultOnSkip}
          onSuccess={onSuccess || defaultOnSuccess}
          phoneNumber={phoneNumber}
          showSkip={showSkip}
          twofaMethod={twofaMethod}
          userFlow={userFlow}
        />
      )}
      {error && <Toast color="red" noAutoDismiss showCloseIcon text={error} />}
    </div>
  )
}
